import { inject, Injectable } from "@angular/core";
import { RequestContextService } from "./request-context.service";
import { bugsnagClient } from "@shared/libs/bugsnag";
import { encrypt } from "@utils/encrypt/encrypt";

@Injectable()
export class BugsnagContextService {
  private readonly ctx = inject(RequestContextService);
  init() {
    bugsnagClient?.addOnError((event) => {
      event.addMetadata("http", {
        requestHeaders: this.ctx.requestHeaders,
        responseHeaders: this.ctx.responseHeaders,
      });

      const traceparent = this.ctx.requestHeaders?.["traceparent"];

      event.addMetadata("tracing", {
        traceId: traceparent?.split("-")[1],
        traceparent,
        vssTracing: this.ctx.requestHeaders?.["vss-tracing"],
        sessionId: this.ctx.requestHeaders?.["vss-session-id"],
      });
    });
  }

  setUser(id?: string | null, email?: string | null): void {
    bugsnagClient?.setUser(id, email ? encrypt(email) : email);
  }
}
